import domReady from "@wordpress/dom-ready";

domReady(() => {

    const galleries = document.querySelectorAll(".wp-block-celebrate-suite-celebrate-custom-field .celebrate-custom-field-slider");

    galleries.forEach((gallery) => {
        const parent = gallery.closest('.wp-block-celebrate-suite-celebrate-custom-field');
        if (parent) {
            const navigation = parent.getAttribute('data-navigation') === 'true';
            const pagination = parent.getAttribute('data-pagination') === 'true';
            const autoplay = parent.getAttribute('data-autoplay') === 'true';
            const autoplaySpeed = parseInt(parent.getAttribute('data-autoplaySpeed')) || 4000;
            const groupCells = parent.getAttribute('data-groupCells') === 'true';
            const centerMode = parent.getAttribute('data-centerMode') === 'true';
            imagesLoaded(gallery, () => {
                const flkty = new Flickity(gallery, {
                    cellAlign: centerMode ? "center" : "left",
                    contain: true,
                    draggable: true,
                    wrapAround: true,
                    autoPlay: autoplay ? autoplaySpeed : false,
                    prevNextButtons: navigation,
                    pageDots: pagination,
                    groupCells: groupCells
                });
            });
        }
    });

    const carousels = document.querySelectorAll(".wp-block-celebrate-suite-celebrate-custom-field .celebrate-custom-field-carousel");

    carousels.forEach((carousel) => {
        const parentcar = carousel.closest('.wp-block-celebrate-suite-celebrate-custom-field');
        if (parentcar) {
            const navigation = parentcar.getAttribute('data-navigation') === 'true';
            const pagination = parentcar.getAttribute('data-pagination') === 'true';
            const autoplay = parentcar.getAttribute('data-autoplay') === 'true';
            const autoplaySpeed = parseInt(parentcar.getAttribute('data-autoplaySpeed')) || 4000;

            const flktyc = new Flickity(carousel, {
                cellAlign: "center",
                contain: true,
                draggable: true,
                wrapAround: true,
                autoPlay: autoplay ? autoplaySpeed : false,
                prevNextButtons: navigation ? true : false,
                pageDots: pagination ? true : false
            });
        }
    });

    const rotators = document.querySelectorAll(".wp-block-celebrate-suite-celebrate-custom-field .celebrate-custom-field-rotator .wp-block-gallery");

    rotators.forEach((rotator) => {
        const parentrot = rotator.closest('.wp-block-celebrate-suite-celebrate-custom-field');
        if (parentrot) {
            const navigation = parentrot.getAttribute('data-navigation') === 'true';
            const pagination = parentrot.getAttribute('data-pagination') === 'true';
            const autoplay = parentrot.getAttribute('data-autoplay') === 'true';
            const autoplaySpeed = parseInt(parentrot.getAttribute('data-autoplaySpeed')) || 4000;

            const flktyr = new Flickity(rotator, {
                cellAlign: "left",
                contain: true,
                draggable: true,
                imagesLoaded: true,
                wrapAround: true,
                fade: true,
                selectedAttraction: 0.009,
                autoPlay: autoplay ? autoplaySpeed : false,
                prevNextButtons: navigation ? true : false,
                pageDots: pagination ? true : false,
                setGallerySize: false
            });

            const updateGalleryHeight = () => {
                const galleryWrapper = rotator.closest(".wp-block-celebrate-suite-celebrate-custom-field");
                const aspectRatioParts = galleryWrapper.getAttribute("data-aspect-ratio").split("/");
                let aspectRatioWidth = 1;
                let aspectRatioHeight = 1;
                if (aspectRatioParts.length === 1) { 
                    aspectRatioWidth = aspectRatioHeight = parseFloat(aspectRatioParts[0]);
                } else if (aspectRatioParts.length === 2) {
                    aspectRatioWidth = parseFloat(aspectRatioParts[0]);
                    aspectRatioHeight = parseFloat(aspectRatioParts[1]);
                }
                const galleryWidth = rotator.clientWidth;
                const calculatedHeight = galleryWidth * (aspectRatioHeight / aspectRatioWidth);
                rotator.style.height = calculatedHeight + "px";
            };
            flktyr.on("select", updateGalleryHeight);
            window.addEventListener("resize", updateGalleryHeight);
            updateGalleryHeight();
        }
    });

    const slideshows = document.querySelectorAll(".wp-block-celebrate-suite-celebrate-custom-field .celebrate-custom-field-slideshow");
    const navslideshows = document.querySelectorAll(".wp-block-celebrate-suite-celebrate-custom-field .celebrate-custom-field-nav-slideshow");

    slideshows.forEach((slideshow) => {
        const parentdiv = slideshow.closest('.wp-block-celebrate-suite-celebrate-custom-field');
        if (parentdiv) {
            const navigation = parentdiv.getAttribute('data-navigation') === 'true';
            const pagination = parentdiv.getAttribute('data-pagination') === 'true';
            const autoplay = parentdiv.getAttribute('data-autoplay') === 'true';
            const autoplaySpeed = parseInt(parentdiv.getAttribute('data-autoplaySpeed')) || 4000;
            const groupCells = parentdiv.getAttribute('data-groupCells') === 'true';
            const centerMode = parentdiv.getAttribute('data-centerMode') === 'true';

            const flktys = new Flickity(slideshow, {
                cellAlign: "left",
                contain: true,
                draggable: true,
                wrapAround: true,
                autoPlay: autoplay ? autoplaySpeed : false,
                prevNextButtons: navigation ? true : false,
                pageDots: pagination ? true : false,
            });

            const navslideshow = parentdiv.querySelector('.celebrate-custom-field-nav-slideshow');
            if (navslideshow) {
                new Flickity(navslideshow, {
                    asNavFor: slideshow,
                    contain: true,
                    pageDots: false,
                    prevNextButtons: false,
                    cellAlign: "center",
                    wrapAround: true,
                });
            }
        }
    });

});
